import { styled } from '@/lib/utils'

export const PipelineBoardWrapper = styled('div')(
  'relative overflow-hidden shadow-inner rounded-lg',
  'bg-[var(--color-background)] bg-[radial-gradient(circle,_var(--color-sidebar-border)_1px,_transparent_1px)] bg-[length:16px_16px]',
  'backdrop-blur-xs border h-[calc(100vh-110px)] min-h-[100px] justify-center items-start'
)

export const PipelineStageWrapper = styled('div')(
  'absolute inset-0 h-full w-full overflow-auto flex flex-col'
)
